import { Site } from '@envato/foundation-types'
import * as React from 'react'

import quickLinksConfig from '../../../config/layout/quickLinks'
import TextLink from '../textLink/textLink'

import * as styles from './siteLinks.module.css'

interface ILink {
  url: string
  label: string
}
interface IProps {
  currentSite: Site
  site: keyof typeof quickLinksConfig
}

const SiteLinks = ({ currentSite, site }: IProps) => {
  const { label, internal_links, cross_site_links } = quickLinksConfig[site]
  const links = currentSite === site ? internal_links : cross_site_links

  return (
    <ul className={styles.list}>
      <li className={styles.listTitle}>{label}</li>
      {links.map((linkConfig: ILink, key: number) => (
        <li key={key} className={styles.listItem}>
          <TextLink href={linkConfig.url} className={styles.link}>
            {linkConfig.label}
          </TextLink>
        </li>
      ))}
    </ul>
  )
}

export default SiteLinks
